<template>
    <input v-model="valueWithCommas"
           :min="min" :class="classProp" class="form-control"
           type="text">
</template>

<script>
    export default {
        name: 'CommaInput',
        props: {
            value: {
                type: Number,
            },
            min: {
                type: String,
            },
            classProp: {
                type: Object,
            },
        },
        data() {
            return {
                valueWithCommas: this.changeToCommas(this.value),
            };
        },
        watch: {
            valueWithCommas(value) {
                const sanitizedCommasValue = this.removeCommas(value);

                this.valueWithCommas = this.changeToCommas(sanitizedCommasValue);
                this.$emit('input', sanitizedCommasValue);
            }
        },
        methods: {
            changeToCommas(number) {
                return Number(number).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
            },
            removeCommas(string){
                return Number(string.replace(/(\D)/g, ''));
            }
        }
    };
</script>